import OcppTagResponseDTO from "../../../../../shared/oversight-core/dtos/response-dtos/ocpp-tag-response-dto";
import AppDropDown from "../../../../../shared/oversight-core/ui-elements/app-dropdown/app-drop-down";
import MaterialIcon from "../../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import styles from "./rfid-user-card.module.scss";

interface IProps {
  item: OcppTagResponseDTO;
  onEdit: (item: OcppTagResponseDTO) => void;
  onRemove: (item: OcppTagResponseDTO) => void;
  onAssignUser: (item: OcppTagResponseDTO) => void;
}

const RfidUserCard = ({ item, onEdit, onRemove, onAssignUser }: IProps) => {
  const fields = [
    { label: "Name", value: item.holderName },
    { label: "Email", value: item.email },
    { label: "Note", value: item.note },
  ];

  return (
    <div className={styles.rfidCard}>
      <div className={styles.header}>
        <div className={styles.identity}>
          <div className={styles.iconWrap}>
            <MaterialIcon icon="credit_card" color="var(--icon-color)" size={20} />
          </div>
          <div className={styles.identityText}>
            <span className={styles.rfidLabel}>RFID</span>
            <span className={styles.rfidValue}>{item.idTag || "-"}</span>
          </div>
        </div>
        <AppDropDown
          items={[
            {
              text: "Edit",
              onClick: () => onEdit(item),
            },
            {
              text: "Remove",
              onClick: () => onRemove(item),
            },
            {
              text: "Assign User",
              onClick: () => onAssignUser(item),
            },
          ]}
          hasDropdownBg={false}
        />
      </div>
      <div className={styles.fields}>
        {fields.map((field) => (
          <div key={field.label} className={styles.fieldRow}>
            <span className={styles.fieldLabel}>{field.label}</span>
            <span className={styles.fieldValue}>{field.value || "-"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RfidUserCard;
